// extracted by mini-css-extract-plugin
module.exports = {"table":"srdjtj_table__1GTUg","cell":"srdjtj_cell__27OGg","row_sum":"srdjtj_row_sum__iWMEY","celldanger":"srdjtj_celldanger__GIts-"};